import SDK from "../config";
import axios from "axios";

const baseUrl = SDK.getBaseUrl("subscription");

class SubscriptionService {
 
  static async checkSubscriptionStatus(email) {
    try {
       console.log(baseUrl)
      const response = await axios.get(
        `${baseUrl}/subscription/status/${email}`
      );
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
  static async intializePayment(data) {
    try {
      const response = await axios.post(
        `${baseUrl}/subscription/initialize`,
        data
      );
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
 static async createSubscription(data) {
  try {
    const response = await axios.post(`${baseUrl}/subscription/create`, data);
    return {
      success: true,
      data: response.data.data,
      status: response.status
    };
  } catch (error) {
    return {
      success: false,
      status: error.response?.status,
      message: error.response?.data?.message || "Payment failed",
      error: error.response?.data
    };
  }
}


}
export default SubscriptionService;
